
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import './Indent.css';

const Indent = ({ screenAction, setScreenAction, triggerSave }) => {

    const [items, setItems] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [locations, setLocations] = useState([]);
    const [indentList, setIndentList] = useState([]);

    const [showSearch, setShowSearch] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [formMode, setFormMode] = useState("create");

    const [filteredItems, setFilteredItems] = useState({});
    const [selectedLocation, setSelectedLocation] = useState(null);

    const [formData, setFormData] = useState({
        Location_id: '',
        Indent_no: '',
        // Indent_dt: '',
        Indent_dt: new Date().toISOString().split('T')[0],
        Indent_Req_by: '',
        Dept_id: ''
    });

    const [rows, setRows] = useState(
        [...Array(10)].map(() => ({
            itemCd: '',
            itemDesc: '',
            itemUOM: '',
            Req_dt: '',
            Supp_id: '',
            Qty: '',
            Remarks: '',
            Approved_qty: '',
            Approved_by: '',
            close: ''
        }))
    );

    const user = JSON.parse(localStorage.getItem('user'));
    const userName = user ? user.name : '';

    useEffect(() => {
        if (!screenAction) return;

        if (screenAction === "add") {
            clearForm();
            setShowSearch(false);
            setIsEditing(true);
            setFormMode("create");
        }

        if (screenAction === "edit") {
            setShowSearch(true);
            setIsEditing(true);
            setFormMode("edit");
            fetchIndentNos();
        }

        if (screenAction === "view") {
            setShowSearch(true);
            setIsEditing(false);
            setFormMode("view");
            fetchIndentNos();
        }

        if (screenAction === "approve") {
            setShowSearch(true);
            setIsEditing(true);
            setFormMode("approve");
            fetchIndentNos();
        }

        if (screenAction === "save") {
            handleSave();
        }

    }, [screenAction]);
    // ================= FETCH MASTER =================
    useEffect(() => {
        axios.get('https://hmsapi.emedhatechnologies.com/master/api/api/location')
            .then(res => setLocations(res.data));

        axios.get('https://hmsapi.emedhatechnologies.com/master/api/api/depertament')
            .then(res => setDepartments(res.data));

        axios.get('https://hmsapi.emedhatechnologies.com/master/api/api/suppliers')
            .then(res => setSuppliers(res.data));

        axios.get('https://hmsapi.emedhatechnologies.com/master/api/api/itemsmasterform')
            .then(res => setItems(res.data));
    }, []);

    const fetchIndentNos = async () => {
        try {
            const res = await fetch('https://hmsapi.emedhatechnologies.com/master/api/sss/pur-indent');
            const data = await res.json();

            if (data && typeof data === 'object') {
                setFilteredItems(data);
            }
        } catch (err) {
            console.error("Indent Nos error", err);
        }
    };
    const handleSearchLocation = (selectedOption) => {
        const locId = selectedOption?.value;
        setSelectedLocation(locId);

        setFormData(prev => ({
            ...prev,
            Location_id: locId
        }));

    };

    const searchLocationOptions = Object.keys(filteredItems).map(key => ({
        value: key,
        label: `${key} - ${filteredItems[key]?.location_desc || ''}`
    }));

    const indentOptions =
        selectedLocation &&
            filteredItems[selectedLocation]?.indent_nos
            ? filteredItems[selectedLocation].indent_nos.map(no => ({
                value: no,
                label: no
            }))
            : [];

    const handleLocationSelect = async (selectedOption) => {
        const locationId = selectedOption ? selectedOption.value : '';

        // ✅ ALWAYS store location
        setFormData(prev => ({
            ...prev,
            Location_id: locationId
        }));

        // Only generate indent in create mode
        if (formMode === "create" && locationId) {
            try {
                const response = await axios.get(
                    `https://hmsapi.emedhatechnologies.com/master/api/generate-indent-no?Location_id=${locationId}`
                );

                const indentNo = response.data?.indent_no || '';

                setFormData(prev => ({
                    ...prev,
                    Location_id: locationId,
                    Indent_no: indentNo
                }));

            } catch (err) {
                console.log("Indent number error", err);
            }
        }
    };

    // // ================= CLEAR =================
    const clearForm = () => {

        setFormData({
            Location_id: '',
            Indent_no: '',
            Indent_dt: new Date().toISOString().split('T')[0],
            Indent_Req_by: '',
            Dept_id: ''
        });

        setRows([...Array(10)].map(() => ({
            itemCd: '',
            itemDesc: '',
            itemUOM: '',
            Req_dt: '',
            Supp_id: '',
            Qty: '',
            Remarks: '',
            Approved_qty: '',
            Approved_by: '',
            close: ''
        })));
    };

    const [empData, setEmpData] = useState([]);

    // const fetchEmpData = async () => {
    //     try {
    //         const user = JSON.parse(localStorage.getItem("user"));

    //         const response = await axios.get(
    //             "https://hmsapi.emedhatechnologies.com/master/api/api/get-Company-data"
    //         );
    //         console.log('this is user', user)
    //         console.log('this is response', response)

    //         const loggedEmployee = response.data.find(
    //             (emp) => emp.email === user.email
    //         );

    //         console.log('this is loggedEmployee',loggedEmployee)

    //         if (!loggedEmployee) {
    //             console.error("Employee not found");
    //             return;
    //         }


    //         setEmpData(loggedEmployee); // Store company data

    //     } catch (err) {
    //         console.error("Error fetching company data");
    //     }
    // };
    // useEffect(() => {
    //     fetchEmpData();
    // }, []);


    const fetchEmpData = async () => {
        try {
            // 1. Get logged-in user from localStorage
            const user = JSON.parse(localStorage.getItem("user"));
    
            // 2. Fetch employee data
            const empRes = await axios.get(
                "https://hmsapi.emedhatechnologies.com/master/api/api/get-Employee-data"
            );
    
            // 3. Find logged-in employee using email
            const loggedEmployee = empRes.data.find(
                (emp) => emp.email === user.email
            );
    
            if (!loggedEmployee) {
                console.error("Employee not found");
                return;
            }
    
            const hospitalId = loggedEmployee.hospital_id;
    
            // 4. Fetch company data
            const compRes = await axios.get(
                "https://hmsapi.emedhatechnologies.com/master/api/api/get-Company-data"
            );
    
            // 5. Filter company using hospital_id
            const matchedCompany = compRes.data.find(
                (comp) => comp.id === hospitalId
            );
    
            // 6. Store only matched company
            setEmpData(matchedCompany);
    
        } catch (err) {
            console.error("Error fetching company data", err);
        }
    };
    
    useEffect(() => {
        fetchEmpData();
    }, []);

    console.log('this is empData', empData)
    // ================= SAVE (POST + PUT) =================
    const handleSave = async () => {

        const { Location_id, Indent_no, Indent_dt, Dept_id } = formData;
        console.log("FORM DATA:", formData);
        console.log('thisi si location all', Location_id, Indent_dt, Dept_id)
        console.log('Indent_no', Indent_no)

        if (!Location_id || !Indent_no || !Dept_id) {
            alert("Fill all required fields");
            return;
        }
        // Filter only rows that have an item selected
        // const filledRows = rows.filter(row => row.itemCd !== '');

        // const filledRows = rows.filter(row => row.itemCd !== '').map(row => ({
        //     ...row,
        //     // If we are in approve mode, set Approved_by to current user, 
        //     // otherwise keep what was there (or null)
        //     Approved_by: formMode === "approve" ? (user ? user.id : row.Approved_by) : row.Approved_by
        // }));


        const filledRows = rows
            .filter(row => row.itemCd !== '')
            .map(row => ({
                ...row,

                Approved_qty: row.Approved_qty || null,

                Approved_by:
                    formMode === "approve"
                        ? (row.Approved_by || (user ? user.id : null))
                        : null,   // ✅ force null in create/edit

                close:
                    formMode === "approve"
                        ? row.close || null
                        : null
            }));


        if (filledRows.length === 0) {
            alert("Please add at least one item");
            return;
        }



        const requestData = {
            Location_id,
            Indent_no,
            Indent_dt,
            Dept_id,
            Indent_Req_by: user ? user.id : '',
            // items: rows,
            items: filledRows,   // ✅ CORRECT
            mode: formMode,
            hospital_id:empData.id,
        };



        try {
            // if (isEditing) {
            if (formMode === "edit" || formMode === "approve") {
                await axios.put(`https://hmsapi.emedhatechnologies.com/master/api/pur-indent/${Indent_no}`, requestData);
                alert("Updated Successfully");
            } else {
                await axios.post(`https://hmsapi.emedhatechnologies.com/master/api/api/pur-indent`, requestData);
                alert("Saved Successfully");
            }

            // fetchIndentList();
            // fetchIndentDetails();
            fetchIndentDetails(formData.Location_id, formData.Indent_no);

        } catch (err) {
            console.log(err);
            alert("Error Saving");
        }
    };

    // ================= INPUT =================
    const handleInputChange = (e, index = null) => {
        const { name, value } = e.target;

        if (index !== null) {
            const updatedRows = [...rows];
            updatedRows[index][name] = value;
            setRows(updatedRows);
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    // ================= SELECT OPTIONS =================
    const locationOptions = locations.map(loc => ({
        value: loc.Location_Id,
        label: `${loc.Location_Desc}-${loc.Location_Id}`
    }));

    const departmentOptions = departments.map(dept => ({
        value: dept.Dept_id,
        label: `${dept.Dept_name}-${dept.Dept_id}`
    }));

    const itemOptions = items.map(item => ({
        value: item.itemCd,
        label: `${item.itemCd} - ${item.itemDesc}`
    }));


    console.log('this is indentList', indentList)

    const handleItemSelect = (selectedOption, index) => {
        const selectedItem = items.find(item => item.itemCd === selectedOption.value);
        const updatedRows = [...rows];
        updatedRows[index].itemCd = selectedItem.itemCd;
        updatedRows[index].itemDesc = selectedItem.itemDesc;
        updatedRows[index].itemUOM = selectedItem.itemUOM;
        setRows(updatedRows);
    };

    const fetchIndentDetails = async (Location_id, indentNos) => {

        if (!Location_id || !indentNos) {
            console.log("Missing params:", Location_id, indentNos);
            return;
        }
        try {
            const response = await axios.get(`https://hmsapi.emedhatechnologies.com/master/api/combined-indent/${Location_id}/${indentNos}`);
            const data = response.data.data;
            console.log(response.data)
            if (data && data.length > 0) {
                const updatedRows = [...Array(10)].map(() => ({ itemCd: '', itemDesc: '', itemUOM: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' }));
                data.forEach((row, index) => {

                    // --- FIX FOR DATE SHIFT ---
                    let formattedReqDt = "";
                    if (row.Req_dt) {
                        const d = new Date(row.Req_dt);
                        // Add 5.5 hours (or just use the Date object methods which use local time)
                        // This ensures 18:30 UTC becomes 00:00 Local (the correct day)
                        const year = d.getFullYear();
                        const month = String(d.getMonth() + 1).padStart(2, '0');
                        const day = String(d.getDate()).padStart(2, '0');
                        formattedReqDt = `${year}-${month}-${day}`;
                    }
                    // --------------------------

                    updatedRows[index] = {
                        itemCd: row.itemCd || '',
                        itemDesc: row.itemDesc || '',
                        itemUOM: row.itemUOM || '',
                        // Req_dt: row.Req_dt ? row.Req_dt : new Date().toISOString().split('T')[0],
                        // FIX: Extract only the YYYY-MM-DD part directly from the string
                        // Req_dt: row.Req_dt ? row.Req_dt.substring(0, 10) : new Date().toLocaleDateString('en-CA'),
                        Req_dt: formattedReqDt, // Use the fixed date string
                        Supp_id: row.Supp_id || '',
                        Qty: row.Qty || '',
                        Remarks: row.Remarks || '',
                        Approved_qty: row.Approved_qty || '',
                        Approved_by: row.Approved_by || '',
                        Emp_Name: row.Emp_Name || '',
                        close: row.Close || ''
                    };
                });
                setRows(updatedRows);
                const uniqueData = data.filter((value, index, self) =>
                    index === self.findIndex((t) => (
                        t.Location_id === value.Location_id &&
                        t.Indent_no === value.Indent_no &&
                        t.itemCd === value.itemCd
                    ))
                );
                if (uniqueData.length > 0) {
                    const indentHeader = uniqueData[0];
                    // Do the same for the Header Date
                    const header = data[0];
                    const hd = new Date(header.Indent_Header_Dt);
                    const headerDate = `${hd.getFullYear()}-${String(hd.getMonth() + 1).padStart(2, '0')}-${String(hd.getDate()).padStart(2, '0')}`;
                    setFormData({
                        Location_id: indentHeader.Location_id || '',
                        Location_Desc: indentHeader.Location_Desc || '',
                        Indent_no: indentHeader.Indent_no || '',
                        //Indent_Header_Dt: indentHeader.Indent_Header_Dt ? indentHeader.Indent_Header_Dt : new Date().toISOString().split('T')[0],  // Make sure Indent_Header_Dt is set
                        // FIX: Map Indent_Header_Dt from API to Indent_dt in State
                        // Indent_dt: indentHeader.Indent_Header_Dt
                        //     ? new Date(indentHeader.Indent_Header_Dt).toISOString().split('T')[0]
                        //     : new Date().toISOString().split('T')[0],
                        Indent_dt: headerDate,
                        Indent_Req_by: indentHeader.Indent_Req_by || '',
                        Dept_id: indentHeader.Dept_id || ''
                    });
                }
            }
        } catch (err) {
            console.error('Error fetching indent details:', err);
        }
    };


    const handleIndentSelect = async (selectedOption) => {
        if (!selectedOption) return;

        if (!selectedLocation) {
            alert("Select Location First");
            return;
        }

        const indentNo = selectedOption.value;

        setFormData(prev => ({
            ...prev,
            Indent_no: indentNo,
            Location_id: selectedLocation
        }));

        await fetchIndentDetails(selectedLocation, indentNo);
    };



    const isViewMode = formMode === "view";
    const isApproveMode = formMode === "approve";

    // disable everything in view
    const isDisabled = isViewMode;

    // allow only approved fields in approve mode
    // const isFieldDisabled = (field) => {
    //     if (formMode === "view") return true;

    //     if (formMode === "approve") {
    //         return !["Approved_qty", "close"].includes(field);
    //     }

    //     return false; // add/edit mode
    // };
    const isFieldDisabled = (field) => {
        if (formMode === "view") return true;
        if (formMode === "approve") {
            return !["Approved_qty", "Approved_by", "close"].includes(field); // Only these 2 are editable
        }
        // In add/edit mode, disable the approval fields  
        // Approved_by: row.Approved_by || '',
        if (["Approved_qty", "Approved_by", "close"].includes(field)) return true;

        return false;
    };

    const [companyData, setCompanyData] = useState([]);

    const fetchCompanyData = async () => {
        try {
            const response = await axios.get(
                "https://hmsapi.emedhatechnologies.com/master/api/api/get-Employee-data"
            );
            setCompanyData(response.data); // Store company data
        } catch (err) {
            console.error("Error fetching company data");
        }
    };
    useEffect(() => {
        fetchCompanyData();
    }, []);

    console.log('this is companyData', companyData)

    const getEmployeeName = (id) => {
        const emp = companyData.find(e => e.id === Number(id));
        return emp ? emp.name : '';
    };

    // ================= UI =================
    return (
        <div className="indent-container">



            {showSearch && (
                <div className="search-box">

                    {/* LOCATION */}
                    <div>
                        <label>Location</label>

                        <Select
                            options={searchLocationOptions}
                            value={searchLocationOptions.find(o => o.value === selectedLocation)}
                            onChange={handleSearchLocation}
                            placeholder="Search or Select Location"
                            isSearchable
                        />
                    </div>

                    {/* INDENT NO */}
                    <div>
                        <label>Indent No</label>

                        <Select
                            options={indentOptions}
                            value={indentOptions.find(o => o.value === formData.Indent_no)}
                            onChange={handleIndentSelect}
                            placeholder="Select Indent No"
                            isSearchable
                        />
                    </div>

                </div>
            )}

            <div className="indent-form">

                <div className="form-row">
                    <label>Location</label>

                    <Select
                        options={locationOptions}
                        value={locationOptions.find(o => o.value === formData.Location_id)}
                        onChange={handleLocationSelect}
                        isDisabled={isDisabled}
                    />
                </div>


                <div className="form-row">
                    <label>Indent No</label>
                    <input value={formData.Indent_no} readOnly />
                </div>

                <div className="form-row">
                    <label>Indent Req By</label>
                    <input value={userName} readOnly />
                </div>

                <div className="form-row">
                    <label>Department</label>
                    <Select
                        options={departmentOptions}
                        onChange={(e) => setFormData({ ...formData, Dept_id: e.value })}
                        value={departmentOptions.find(o => o.value === formData.Dept_id)}
                        isDisabled={isDisabled}
                    />
                </div>

                <div className="form-row">
                    <label>Indent Date</label>
                    <input
                        type="date"
                        name="Indent_dt"
                        value={formData.Indent_dt}
                        onChange={handleInputChange}
                        disabled={isDisabled}
                    />
                </div>

            </div>

            <div className="indent-table">
                <table>
                    <thead>
                        <tr>
                            <th>Sl No</th>
                            <th>Item</th>
                            <th>Description</th>
                            <th>UOM</th>
                            <th>Req Date</th>
                            <th>Supplier</th>
                            <th>Qty</th>
                            <th>Remarks</th>
                            <th>Approved Qty</th>
                            <th>Approved By</th>
                            <th>Close</th>
                        </tr>
                    </thead>

                    <tbody>
                        {rows.map((row, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>

                                <td style={{ width: '200px' }}>
                                    {/* <Select
                                        options={itemOptions}
                                        onChange={(opt) => handleItemSelect(opt, index)}
                                    /> */}
                                    <Select
                                        options={itemOptions}
                                        value={itemOptions.find(o => o.value === row.itemCd)}
                                        onChange={(opt) => handleItemSelect(opt, index)}
                                        isDisabled={isFieldDisabled("itemCd")}
                                    />
                                </td>

                                <td><input value={row.itemDesc} readOnly /></td>
                                <td><input value={row.itemUOM} readOnly /></td>

                                <td>
                                    {/* <input
                                        type="date"
                                        name="Req_dt"
                                        value={row.Req_dt}
                                        onChange={(e) => handleInputChange(e, index)}
                                    /> */}
                                    {/* <input
                                        type="date"
                                        name="Req_dt"
                                        value={
                                            row.Req_dt
                                                ? new Date(row.Req_dt).toISOString().split('T')[0]
                                                : ''
                                        }
                                        onChange={(e) => handleInputChange(e, index)}
                                        disabled={isFieldDisabled("Req_dt")}
                                    /> */}

                                    <input
                                        type="date"
                                        name="Req_dt"
                                        // Simply use the value from state; it should be in YYYY-MM-DD format
                                        value={row.Req_dt || ''}
                                        onChange={(e) => handleInputChange(e, index)}
                                        disabled={isFieldDisabled("Req_dt")}
                                    />
                                </td>

                                <td>
                                    <select
                                        name="Supp_id"
                                        value={row.Supp_id}
                                        onChange={(e) => handleInputChange(e, index)}
                                        disabled={isFieldDisabled("Supp_id")}
                                    >
                                        <option>Select</option>
                                        {suppliers.map(s => (
                                            <option key={s.Supp_cd} value={s.Supp_cd}>
                                                {s.Supp_Nm}
                                            </option>
                                        ))}
                                    </select>
                                </td>

                                <td>
                                    <input
                                        name="Qty"
                                        value={row.Qty}
                                        onChange={(e) => handleInputChange(e, index)}
                                        disabled={isFieldDisabled("Qty")}
                                    />
                                </td>

                                <td>
                                    <input
                                        name="Remarks"
                                        value={row.Remarks}
                                        onChange={(e) => handleInputChange(e, index)}
                                        disabled={isFieldDisabled("Remarks")}
                                    />
                                </td>

                                <td>
                                    <input
                                        name="Approved_qty"
                                        value={row.Approved_qty}
                                        onChange={(e) => handleInputChange(e, index)}
                                        disabled={isFieldDisabled("Approved_qty")}
                                    />
                                </td>
                                <td>
                                    <input
                                        name="Approved_by"
                                        //  value={row.Approved_by}
                                        //value={getEmployeeName(row.Approved_by)}
                                        readOnly   // 🔥 important (since you're showing name, not editing id)
                                        value={row.Approved_by ? `${getEmployeeName(row.Approved_by)} (Approved)` : user?.name || ''}
                                        onChange={(e) => handleInputChange(e, index)}
                                        disabled={isFieldDisabled("Approved_by")}
                                    />
                                </td>

                                <td>
                                    <select
                                        name="close"
                                        value={row.close}
                                        onChange={(e) => handleInputChange(e, index)}
                                        disabled={isFieldDisabled("close")}
                                    >
                                        <option value="">Select</option>
                                        <option value="Y">Y</option>
                                        <option value="N">N</option>
                                    </select>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        </div>
    );
};

export default Indent;